import ITodoListObservable = app.tsmodels.interfaces.ITodoListObservable;

export default class TodoListFactory {
  public create(): ITodoListObservable {
    return {
      TodoListId: ko.observable(0),
      Todos: ko.observableArray()
    } as ITodoListObservable;
  }
}
